import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/inspect'

// /** 获取待检工单数据 */
// export const getWaitInspectBatchOrderPage = (params) => {
//     return axios.post(`${rootApi}/workOrder/waitInspectBatchOrderPage`, params, { dataType: 'json' })
// }

/** 获取待检工单数据 */
export const getWaitInspectBatchOrderPage = (params) => {
    return axios.post(`${rootApi}/workOrderMerge/waitInspectBatchOrderPage`, params, { dataType: 'json' })
}

/** 获取已检工单数据 */
export const getCompleteInspectBatchOrderPage = (params) => {
    return axios.post(`${rootApi}/workOrderMerge/completeInspectBatchOrderPage`, params, { dataType: 'json' })
}
/** 提交合批分检数据 */
export const submitBatchOrderSplit=(params)=>{
    return axios.post(`${rootApi}/workOrder/judge/submit`,params,{dataType:'json'})
}
/** 提交合批合检数据 */
export const submitBatchOrderMerge=(params)=>{
    return axios.post(`${rootApi}/workOrderMerge/complete/submit`,params,{dataType:'json'})
}
/** 获取已检合并工单下的所有物料 */
export const getAllMateriel=(workOrderId)=>{
    return axios.get(`${rootApi}/workOrderMerge/getChildWorkOrderByMergeWorkOrderId/${workOrderId}`)
}
